module.exports = __webpack_public_path__ + "static/linkedin-154e38e667a5263d67c115cc0b5144e2.png";